import React from 'react';
import {ResponsiveContainer, AreaChart, XAxis, YAxis, Tooltip, Area, CartesianGrid} from 'recharts';
import CustomTooltip from '../CustomTooltip'

class GraphTopTrackers extends React.Component {

  render() {

    const { data, t } = this.props
    const translated = data.map( item => (
      {name: t(item.name) === 'Dec' ? 'Dec   ' : t(item.name), value: item.value}
    ))

    return (
      <div style={styles.container} id="skillslogged">
        <ResponsiveContainer width="100%" height={350}>
          <AreaChart data={translated}>
            <YAxis dataKey="value" allowDecimals={false} tickLine={false} axisLine={{stroke: '#67B5E7'}} />
            <XAxis dataKey="name" tickLine={false} axisLine={{stroke: '#67B5E7'}} />
            <defs>
              <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#76DFFB" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#76DFFB" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" />
            <Area
              dataKey="value"
              fill="url(#gradient)"
              activeDot={{ stroke: '#76DFFB' }}
              stroke={'#4085DE'}
            />
            <Tooltip
              cursor={false}
              content={<CustomTooltip data={this.props.data} />}
              wrapperStyle={styles.wrapper}
              labelStyle={styles.label}
              itemStyle={styles.label}
              />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    )
  }
}

export default GraphTopTrackers;

const styles = {

  wrapper: {
    backgroundColor: '#485465',
    border: 'none'
  },

  label: {
    fontSize: '11px'
  },


  title: {
    fontSize: '16px',
    color: '#485465'
  }

}



// WEBPACK FOOTER //
// ./src/components/GraphSkillsLogged/index.jsx